import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useLangPath } from "@/contexts/I18nContext";

/**
 * Drop-in replacement for react-router-dom's <Link>. Automatically
 * prefixes the `to` prop with the current language (e.g. "/pms" →
 * "/en/pms" when the visitor is browsing the English tree).
 *
 * External URLs (http, mailto, tel, #) are passed through untouched.
 */
export function LangLink({ to, ...rest }) {
  const prefix = useLangPath();
  const target = typeof to === "string" ? prefix(to) : to;
  return <Link to={target} {...rest} />;
}

/** Same as LangLink, for <NavLink>. */
export function LangNavLink({ to, ...rest }) {
  const prefix = useLangPath();
  const target = typeof to === "string" ? prefix(to) : to;
  return <NavLink to={target} {...rest} />;
}
